import React, { useState, useCallback } from 'react'
import AButton from './AButton'
import EditIcon from '@mui/icons-material/Edit'
import CheckIcon from '@mui/icons-material/Check'
import { LoadingCircIcon } from './Icons'
import { setModes } from 'modules/Utils'

export default function ActionButtons({mode, setMode, action: fnAction, cancel: fnCancel, actionTitle='Save', cancelTitle='Cancel', editTitle='Edit', actionIcon=null, cancelIcon=null, neverShowEdit = false, neverShowAction=false, neverShowCancel=false, alwaysShowAction=false, alwaysShowCancel=false, colorEdit='primary', colorAction='primary', colorCancel='primary', buttonParams={} }) {
  let dynamicActionIcon
  if (mode === 'completing') {
    dynamicActionIcon = <CheckIcon/>
  } else if (mode === 'pending') {
    dynamicActionIcon = <LoadingCircIcon size={14} thickness={5}/>
  } else {
    dynamicActionIcon = actionIcon
  }

  let dynamicCancelIcon
  if (mode === 'completing-cancel') {
    dynamicCancelIcon = <CheckIcon/>
  } else if (mode === 'pending-cancel') {
    dynamicCancelIcon = <LoadingCircIcon size={14} thickness={5}/>
  } else {
    dynamicCancelIcon = cancelIcon
  }

  return <>
    {!neverShowCancel && (alwaysShowCancel || mode === 'editing' || mode === 'pending-cancel' || mode === 'completing-cancel') && <AButton
      onClick={event => {
        if (fnCancel) {
          fnCancel(event, setMode)
        } else {
          setMode('')
        }
      }}
      disabled={mode === 'pending-cancel' || mode === 'completing-cancel'}
      startIcon={dynamicCancelIcon}
      color={colorCancel}
      {...buttonParams}
    >
      {cancelTitle}
    </AButton>}

    {!neverShowAction && (alwaysShowAction || mode === 'editing' || mode === 'pending' || mode === 'completing') && <AButton
      onClick={event => {
        fnAction && fnAction(event, setMode)
      }}
      disabled={mode === 'pending' || mode === 'completing'}
      startIcon={dynamicActionIcon}
      color={colorAction}
      {...buttonParams}
    >
      {actionTitle}
    </AButton>}

    {!mode && !neverShowEdit && (
      <AButton
        startIcon={<EditIcon/>}
        onClick={() => setMode('editing')}
        color={colorEdit}
        {...buttonParams}
      >
        {editTitle}
      </AButton>
    )}
  </>
}

export function DirectActionButton({ action: fnAction, actionTitle, color='primary', buttonParams={}, extraModes=[] }) {
  const [mode, setMode] = useState('editing')

  const wrappedFunction = useCallback(async (e, setMode) => {
    setMode('pending')
    await fnAction()
    await setModes(setMode, extraModes)
    setMode('')
  }, [fnAction, extraModes])

  return <ActionButtons
    actionTitle={actionTitle}
    colorAction={color}
    action={wrappedFunction}
    mode={mode}
    setMode={setMode}
    alwaysShowAction={true}
    neverShowCancel={true}
    neverShowEdit={true}
    buttonParams={buttonParams}
  />
}

export function ControlledActionButton({ mode, setMode, action: fnAction, actionTitle, color='primary', buttonParams={} }) {
  return <ActionButtons
    actionTitle={actionTitle}
    colorAction={color}
    action={fnAction}
    mode={mode}
    setMode={setMode}
    alwaysShowAction={true}
    neverShowCancel={true}
    neverShowEdit={true}
    buttonParams={buttonParams}
  />
}
